// extracted by mini-css-extract-plugin
export default {"publications":"Publications_publications__o-7k6","publication-title":"Publications_publication-title__kq122"};